export default "__VITE_ASSET__BakMMP8Y__"